import { Carousel } from "primereact/carousel";
import { ICarrossel } from "../../interfaces/model/iCarrossel";
import { withImageFallback } from "../../utils/imageFallback";
import textUtils from "../../utils/textUtils";
import { PurpleButton } from "../buttons/purpleButton";
import { CarrouselContainer, TextWrapper } from "./styles";

interface Props {
  newsList: ICarrossel[];
  onImageClick: (image: any) => void;
}

export const Carrousel = ({ newsList, onImageClick }: Props) => {
  function renderButton(item: any) {
    if (item.routerLink || item.imageBanner) {
      return (
        <PurpleButton onClick={() => onImageClick(item)} title="Saber mais" />
      );
    }
  }

  const itemTemplate = (item: any) => {
    const titulo = item?.titulo ?? "";
    const texto = item?.texto ?? "";
    const imagem = withImageFallback(item?.imagem);

    return (
      <CarrouselContainer>
        <TextWrapper>
          <h2>{titulo}</h2>
          <h3>{textUtils.handleTextHigliht(texto, "bold")}</h3>
          <div>{renderButton(item)}</div>
        </TextWrapper>
        <img src={imagem} alt={titulo || "Item do carrossel"} />
      </CarrouselContainer>
    );
  };

  return (
    <div style={{ maxWidth: "100%" }}>
      <Carousel
        value={newsList}
        numScroll={1}
        numVisible={1}
        itemTemplate={itemTemplate}
        autoplayInterval={8000}
      />
    </div>
  );
};
